export default __webpack_public_path__ + "static/media/bg.e4e6ca81.svg";